import React from "react"; 
import { Link } from "react-router-dom";    
import ProductsListContent from "../../../components/Dashboard/ProductsListContent";

const ProductsList = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">


        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Products List</li>
        </ul>
      </div> */}

      <ProductsListContent />
    </>
  );
};

export default ProductsList;
